/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateGrowthCenterDto } from '../../models/create-growth-center-dto';
import { GrowthCenterDto } from '../../models/growth-center-dto';

export interface GrowthCenterControllerCreate$Params {
      body: CreateGrowthCenterDto
}

export function growthCenterControllerCreate(http: HttpClient, rootUrl: string, params: GrowthCenterControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<GrowthCenterDto>> {
  const rb = new RequestBuilder(rootUrl, growthCenterControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GrowthCenterDto>;
    })
  );
}

growthCenterControllerCreate.PATH = '/api/growth-center';
